export default {
  notifyList: {
    items:[], _links: {},_meta: {}
  },
  notifySystemList: {
    items:[], _links: {},_meta: {}
  }
}
